import { Box, Typography, Paper, IconButton, Skeleton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";
import Image from "../../components/Image";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import NoImage from "../../Assests/placeholder.jpg";
import { AppBar, Toolbar, InputBase } from "@mui/material";
import useFetch from "../../hooks/useFetch";
import { Brand_url_top } from "../../api/urls";
const Search = styled(Box)(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#f5f5f5",
  width: "100%",
  maxWidth: "300px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1),
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(1),
  color: "rgba(0, 0, 0, 0.54)",
}));

const StyledInputBase = styled(InputBase)(() => ({
  flex: 1,
  input: {
    padding: 0,
    height: "100%",
    fontSize: "0.95rem",
  },
}));

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
const TopBrand = () => {
  // const location = useLocation();
  const navigate = useNavigate();
  // const { brands = [], title = "Brands" } = location.state || {};
  const [searchQuery, setSearchQuery] = useState("");

  const handleResultClick = (catID) => {
    navigate(`/products?brand=${catID}`, {
      state: { catID: catID },
    });
  };
  const { data: brands, loading } = useFetch(
    Brand_url_top + `&search=${searchQuery}`,
  );
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "transparent",
          color: "black",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "block" },
              marginLeft: "10px",
            }}
          >
            Brands
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            gap={2}
            position="relative"
            marginTop={2}
          >
            <Box position="relative">
              <Search>
                <StyledInputBase
                  placeholder="Search Brands..."
                  inputProps={{ "aria-label": "search" }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                  // onFocus={() =>
                  //   searchResults.length > 0 && setShowResults(true)
                  // }
                />
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
              </Search>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Box p={3}>
        {/* Back button + Title */}
        <motion.div initial="hidden" animate="visible" variants={fadeIn}>
          <Box display="flex" alignItems="center" mb={3}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5" ml={1}>
              Top Brands
            </Typography>
          </Box>
          {loading && (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                p: 2,
                width: "100%",
                margin: "auto",
                justifyContent: { xs: "center", md: "start" },
              }}
            >
              <Skeleton height={300} width={300} />
              <Skeleton height={300} width={300} />
            </Box>
          )}
          {/* Brand Grid */}
          {!loading && (
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(4, 1fr)",
              }}
              gap={2}
            >
              {brands?.map((brand, index) => (
                <motion.div
                  key={brand.id || index}
                  whileHover={{ scale: 1.05 }}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleResultClick(brand?.brand_name)}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: "1px solid #eee",
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <Image
                      src={brand.brand_image_upload || NoImage}
                      alt={brand.brand_name}
                      loading="lazy"
                      style={{
                        width: "250px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                    {/* <Typography>{brand.brand_name}</Typography> */}
                  </Paper>
                </motion.div>
              ))}
            </Box>
          )}
        </motion.div>
      </Box>
    </>
  );
};

export default TopBrand;
